import { sendRequest } from '../send-request';
import { setCurrentBackend } from "../../constants";

interface SignInData {
  email: string;
  password: string;
}

export const signInForm = async (
  endpoint: string,
  data: SignInData,
  navigate: (path: string) => void,
  setSignInError: (error: string) => void,
) => {
  try {
    const raw = JSON.stringify(data);
    const requestOptions = {
      method: 'POST',
      body: raw,
    };

    const response = await sendRequest(endpoint, requestOptions, false, false,false);
    const result = await response.json();

    if (response.status === 200) {
      const backendKey = localStorage.getItem('selectedBackend') || 'live';
      await setCurrentBackend(backendKey);
      const { access_token } = result;
      if (access_token) {
        await localStorage.setItem('bearer', access_token);
        navigate('/');
      }
    } else {
      setSignInError(result.message || result.detail || 'Login failed. Please check your credentials.');
    }
  } catch (err) {
    console.log('error', err);
    setSignInError('An error occurred during sign in. Please try again.');
  }
};
